"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SummaryContext = react_1.createContext({
    dimensions: null,
    priceDisplay: null,
});
exports.default = SummaryContext;
